import { Injectable } from '@angular/core';
import { NavigationMode, NavigationModeResult } from '../capacitor-plugins/navigation-mode';

@Injectable({
  providedIn: 'root',
})
export class NavigationModeService {
  constructor() {}

  async detectNavMode(): Promise<NavigationModeResult> {
    try {
      const res = await NavigationMode.getMode();
      return res;
    } catch (err) {
      return {
        mode: 'buttons',
        isGesture: false,
        navBarVisible: true,
        gestureLeft: 0,
        gestureRight: 0,
      };
    }
  }
}








